<div class="bk-page imp">
  <header class="bk-page__head imp__head">
    <div class="bk-page__intro">
      <button type="button" class="bk-more imp__back" (click)="backToContacts()">
        <span class="bk-sym" aria-hidden="true">arrow_back</span>
        Contacts
      </button>
      <p class="bk-eyebrow">Audience</p>
      <h1 class="bk-page__title">Import contacts</h1>
      <p class="bk-page__sub">{{ description }}</p>
    </div>
  </header>

  <alternative-stepper class="imp__steps" [steps]="steps" [noContent]="true" />

  <div class="imp__body">
    @switch (searchQuery) {
      @case ('mapping') {
        <csv-column-mapping />
      }
      @case ('cleanup') {
        <csv-clean-up />
      }
      @case ('review') {
        <csv-review />
      }
      @case ('feedback') {
        <csv-feedback />
      }
      @default {
        <csv-upload-file />
      }
    }
  </div>
</div>
